module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ThankYou", "Thank you for signing up!") ))==null?'':__t)+
'</legend><p class="success">'+
((__t=( message ))==null?'':__t)+
'</p></fieldset>';
}
return __p;
};
